import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import animations from 'src/styles/animations';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), animations.spin), {}, {
  label: {
    marginTop: '32px'
  },
  form: {
    marginTop: '24px'
  },
  forgot: {
    fontSize: '15px',
    marginTop: '24px',
    fontWeight: '600'
  },
  confirm: {
    marginTop: '24px'
  },
  status: {
    display: 'flex',
    color: "".concat(palette.primary.dark),
    alignItems: 'center',
    '&.checking': {
      color: "".concat(palette.shades[800]),
      '& .MuiSvgIcon-root path': {
        fill: "".concat(palette.shades[800])
      }
    },
    '&.awaiting': {
      color: "".concat(palette.shades[600]),
      '& .MuiSvgIcon-root path': {
        fill: "".concat(palette.shades[600])
      }
    }
  },
  statusIcon: {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiSvgIcon-root path': {
      fill: "".concat(palette.primary.dark)
    }
  },
  statusText: {
    fontWeight: '600',
    fontSize: '18px',
    marginLeft: '8px'
  },
  spinner: {
    '& .MuiSvgIcon-root': {
      display: 'inline-block',
      animation: '$spin 1.3s infinite linear',
      '& path': {
        fill: palette.primary.main
      }
    }
  }
}));
export default useStyles;